import * as React from "react";

interface IProps extends React.SVGProps<SVGSVGElement> {
    height?: number;
    width?: number;
    mainColor?: string;
    accentColor?: string;
    className?: string;
}

export const CheckedBox = (props: IProps) => {
    return (
        <svg
            fill="none"
            stroke={props.mainColor}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            viewBox="0 0 24 24"
            height="1.6em"
            width="1.6em"
            {...props}
        >
            <rect x="3" y="3" width="18" height="18" rx="3" ry="3" />
            <path d="M9 11l3 3L22 7" />
        </svg>
    );
};
